import errorManager from '@/rollbar.js';

const initShowMeasurement = function (select, activity_code) {
  select = $(select);
  const selected = select.children('option:selected');
  const activity_id = selected.attr('data-activity-id');
  if (parseInt(activity_id) == activity_code) {
    // 16 MISURAZIONI
    $('#exam_id_area').show();
    $('#cod_activities_config').prop('readonly', true);
  } else {
    $('#exam_id_area').hide();
    $('#cod_activities_config').prop('readonly', false);
  }
};

const fillMeasurementFields = function (select) {
  const selected = select.children('option:selected');
  if (select.val() && select.val() != '') {
    const descrizione = selected.text();
    const codice = selected.data('cod');
    $('#description_activities_config').val(descrizione);
    $('#cod_activities_config').val(codice);
  }
};

const init = () => {
  try {
    $('#exam_id').change(function () {
      fillMeasurementFields($(this));
    });
  } catch (e) {
    errorManager(e);
  }
};

const showMeasurement = (select, activity_code) => {
  try {
    initShowMeasurement(select, activity_code);
  } catch (e) {
    errorManager(e);
  }
};

window.Activity = {
  init: init,
  showMeasurement: showMeasurement,
};
